export enum DiversificationApiField {
  Issuer = 'issuer',
  Sector = 'sector',
  Cusip = 'cusip',
  MunicipalState = 'municipal_state',
  MaturityYear = 'maturity_year',
  FdicCode = 'fdic_code',
  Insurer = 'insurer',
  UltimateBorrower = 'ultimate_borrower',
  UltimateParent = 'ultimate_parent',
}
